export default "__VITE_ASSET__70dcb886__"